import { cn } from "@/lib/utils";

const MAP = {
  completed: { cls: "bg-[#004e33]/10 text-[#004e33]", label: "Done" },
  passed: { cls: "bg-[#004e33]/10 text-[#004e33]", label: "Passed" },
  in_progress: { cls: "bg-[#0052cc]/10 text-[#0052cc]", label: "In Progress" },
  unlocked: { cls: "bg-[#0052cc]/10 text-[#0052cc]", label: "Unlocked" },
  pending: { cls: "bg-[#F59E0B]/10 text-[#F59E0B]", label: "Pending" },
  submitted: { cls: "bg-[#F59E0B]/10 text-[#F59E0B]", label: "Awaiting Grading" },
  locked: { cls: "bg-gray-100 text-gray-500", label: "Locked" },
  failed: { cls: "bg-[#ba1a1a]/10 text-[#ba1a1a]", label: "Failed" },
  rejected: { cls: "bg-[#ba1a1a]/10 text-[#ba1a1a]", label: "Rejected" },
  approved: { cls: "bg-[#004e33]/10 text-[#004e33]", label: "Approved" },
  active: { cls: "bg-[#004e33]/10 text-[#004e33]", label: "Active" },
  suspended: { cls: "bg-[#ba1a1a]/10 text-[#ba1a1a]", label: "Suspended" },
  none: { cls: "bg-gray-100 text-gray-500", label: "Not Requested" },
};

export function StatusChip({ status, label, className }) {
  const cfg = MAP[status] || { cls: "bg-gray-100 text-gray-500", label: status };
  return (
    <span
      data-testid={`status-chip-${status}`}
      className={cn("inline-flex items-center text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wider", cfg.cls, className)}
    >
      {label || cfg.label}
    </span>
  );
}
